import { Form } from 'react-bootstrap';
import CareMapprButton from '../../Button/CareMapprButton';
import { MyPainHealthUserStatus } from '../../../../lib';

export const MyPainHealthInviteModalHeader = ({
  onHide,
}: {
  onHide: () => void;
}) => {
  return (
    <div className="d-flex align-items-center">
      <button
        onClick={() => onHide()}
        className="d-flex align-items-center gap-2"
      >
        <i
          style={{ color: 'rgba(38, 83, 116, 1)' }}
          className="fas fa-arrow-left"
        />
        <span
          style={{
            color: 'rgba(38, 83, 116, 1)',
            textDecoration: 'underline',
          }}
        >
          Back to mypainhealth app
        </span>
      </button>
    </div>
  );
};

export const MyPainHealthInviteModalBody = ({
  onHide,
  onSendInvite,
  loading,
  value,
  onValueChange,
}: {
  onHide: () => void;
  onSendInvite: (
    normalized?: string,
  ) => Promise<{ success: boolean; data: MyPainHealthUserStatus | null }>;
  loading: boolean;
  value: string;
  onValueChange: (value: string) => void;
}) => {
  return (
    <form
      className="gap-2 py-2 px-4"
      onSubmit={(e) => {
        e.preventDefault();
        const formEl = e.currentTarget as HTMLFormElement;
        const inputEl = formEl.querySelector(
          'input[type="tel"]',
        ) as HTMLInputElement | null;

        const digits = (value || '').replace(/[^\d]/g, '');
        let normalized = digits;
        if (normalized.startsWith('61')) {
          normalized = '0' + normalized.slice(2);
        } else if (/^4\d{8}$/.test(normalized)) {
          normalized = '0' + normalized;
        }

        const isValid = /^04\d{8}$/.test(normalized);
        if (!isValid) {
          if (inputEl) {
            inputEl.setCustomValidity(
              'Please enter a valid Australian phone number',
            );
            inputEl.reportValidity();
          }
          return;
        }

        if (inputEl) {
          inputEl.setCustomValidity('');
        }
        onValueChange(normalized);

        onSendInvite(normalized);
      }}
    >
      <div style={{ fontWeight: '600' }}>Phone number</div>
      <Form.Control
        type="tel"
        inputMode="numeric"
        pattern="(04[0-9]{8}|\+614[0-9]{8})"
        maxLength={12}
        required
        placeholder="Enter phone number"
        onInvalid={(e) => {
          e.currentTarget.setCustomValidity(
            'Please enter a valid Australian phone number',
          );
        }}
        onInput={(e) => {
          e.currentTarget.setCustomValidity('');
        }}
        onChange={(e) => {
          onValueChange(e.target.value);
        }}
        disabled={loading}
        value={value}
      />
      <div className="d-flex align-items-center justify-content-end gap-2">
        <CareMapprButton
          onClick={() => onHide()}
          variant="secondary"
          label="Cancel"
          type="button"
          isLoading={loading}
          disabled={loading}
        />
        <CareMapprButton
          type="submit"
          label="Send"
          isLoading={loading}
          disabled={loading}
        />
      </div>
    </form>
  );
};
